export type AppLanguage = 'sr' | 'en' | 'de' | 'pl' | 'cs' | 'fr';

export const APP_LANGUAGES: AppLanguage[] = ['sr', 'en', 'de', 'pl', 'cs', 'fr'];

export const isAppLanguage = (value: unknown): value is AppLanguage =>
  typeof value === 'string' && (APP_LANGUAGES as string[]).includes(value);
